module.exports = __webpack_public_path__ + "static/media/02.430fed1b.png";